import * as React from "react";

const DataServiceContext = React.createContext(null);

export default DataServiceContext;